@if (store.open()) {
  <div
    class="fixed inset-0 z-[1000] sm:inset-auto sm:bottom-24 sm:right-6 sm:max-h-[calc(100vh-8rem)]"
    [class]="
      store.expanded() ? 'sm:h-[calc(100vh-8rem)] sm:w-[min(720px,calc(100vw-3rem))]' : 'sm:h-[600px] sm:w-[380px]'
    "
    data-cy="agent-chat-frame"
  >
    <app-agent-chat-panel />
  </div>
}

<button
  type="button"
  class="fixed bottom-6 right-6 z-[1000] flex h-14 w-14 items-center justify-center rounded-full bg-brand-600 text-white shadow-lg hover:opacity-90"
  [class.max-sm:hidden]="store.open()"
  [attr.aria-label]="(store.open() ? 'agent-chat.close' : 'agent-chat.open') | translate"
  [attr.aria-expanded]="store.open()"
  (click)="store.toggle()"
  data-cy="agent-chat-launcher"
>
  <mat-icon>{{ store.open() ? 'cancel' : 'chat_bubble' }}</mat-icon>
  @if (store.unreadCount() && !store.open()) {
    <span
      class="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-xs font-semibold"
      data-cy="agent-chat-unread"
    >
      {{ store.unreadCount() }}
    </span>
  }
</button>
